export default __webpack_public_path__ + "static/media/dairy.f1a18dec.webp";